export function getGamePgn (state) {
  return state.boards.pgn
}
export function getGameFen (state) {
  return state.boards.fen
}
export function getGameTurn (state) {
  return state.boards.turn
}
export function getUser (state) {
  return state.user.user
}
export function getGameTimesUsers (state) {
  const times = {
    white: state.boards.twhite,
    black: state.boards.tblack,
    incremento: 0
  }
  return times
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js